export default __webpack_public_path__ + "static/media/online-exam-platform-2.4b2ca00c.jpg";